import { render } from "./PlayVideo.vue?vue&type=template&id=55b893b2&scoped=true"
import script from "./PlayVideo.vue?vue&type=script&lang=js"
export * from "./PlayVideo.vue?vue&type=script&lang=js"

import "./PlayVideo.vue?vue&type=style&index=0&id=55b893b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b893b2"]])

export default __exports__